import { IContentElement } from "../models";

export interface IContentElementSolution extends IContentElement {
    content: IContentElement[];
    hideFromTestTakers: boolean;
    isRubric: boolean;
    isHeaderHidden: boolean;
}

export const solutionEditInfo = {
    editExcludeFields: ['content']
}